import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { FlashService } from "../../../flash/flash.service";
import { ErrorService } from "../../../services/error.service";
import { ExitChecklistService } from "../../../services/exit-checklist.service";

@Component({
  selector: "app-exit-checklist-views",
  templateUrl: "./exit-checklist-views.component.html",
  styleUrls: ["./exit-checklist-views.component.css"],
})
export class ExitChecklistViewsComponent implements OnInit {
  public form: FormGroup;
  currentUser;
  public fields: any[];
  tem: any;
  exp_ans = [];

  inValid: boolean = false;
  errors;
  answers:any[] = [];
  showform;
  params:any;
  public elementName = [];

  constructor(
    private service: ExitChecklistService,
    private flashService: FlashService,
    private spinnerService: Ng4LoadingSpinnerService,
    private errorService: ErrorService,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.spinnerService.show();
     /* Taking values from the url */
    this.route.params.subscribe(
      params => {
        this.params = params;
        this.spinnerService.hide();
      }
    );
    this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
    this.fields = JSON.parse(sessionStorage.getItem("check_all"));

    

    //emp
    this.form = new FormGroup({});
    this.fields.forEach((x) => {
      if (x.type == "checkbox") {
        this.form.addControl(x.name, new FormGroup({}));
        x.options.forEach((o) => {
          (this.form.get(x.name) as FormGroup).addControl(
            o.key,
            new FormControl(false)
          );
        });
      } else {
        this.form.addControl(
          x.name,
          new FormControl(
            x.value || "",
            x.required ? Validators.required : null
          )
        );
      }
    });
    
    this.generateForm()
    this.get_all()
  }

  getFields() {
    return this.fields;
  }

  get_all() {
    this.spinnerService.show();
    this.service.getAllChecklistsAns(this.params.id).subscribe(
      (data) => {
        this.tem = data.body;
        this.answers = this.tem.questions;
        this.answers.forEach(element => {
          this.showform = element.status
        });

        this.spinnerService.hide();
      },
      (err) => {
        this.spinnerService.hide();
        console.log("Get All Checklists Answer Error :",err);
      }
    );
  }

  onSubmit() {
    this.exp_ans = [];

    let keys_data = Object.keys(this.form.value);
    let value_data = Object.values(this.form.value);

    keys_data.forEach((element, index) => {
      
      var item = this.fields.find((item) => item.name === element);

      if ((typeof value_data[index] === "object") === true) {

        let obj = value_data[index];

        var keys = Object.keys(obj);

        var filtered = keys.filter(function (key) {
          return obj[key];
        });
        
        this.exp_ans.push({ name:item.name, id: item.id, ans: filtered });
      } else {
        this.exp_ans.push({ name:item.name, id: item.id, ans: value_data[index] });
      }

      if(value_data[index] === undefined){
        return this.inValid = true
     }

    });

    this.inValid = false;
    
    let obj = Object.values(this.form.value);

   obj.forEach((formValue) => {
      if (formValue === "") {
        this.inValid = true;
      }
    });

    this.elementName = [];

    this.exp_ans.forEach(ele => {
      if(!ele.ans){
        this.elementName.push(ele.name);
      }
    });

    if(this.elementName.length){
      this.inValid = true;
    }

    const payload = {
      emp_id: this.params.id.toString(),
      data: this.exp_ans,
    };   

    payload.data.forEach((ele,index) => {
        if(Array.isArray(ele.ans) === true){
          this.fields.forEach((elem,indexes) => {
           if(index === indexes){
            ele.ans = elem.answer
           }
          });
        }
    });

    if(this.inValid === false) this.verifyChecklistEmployee(payload)
  }

 

  verifyChecklistEmployee(data){
    this.spinnerService.show();
    this.service.verifyChecklistEmployee(data).subscribe(
      (data) => {
        if (data["success"]) {
          this.flashService.show(data["message"], "alert-success");
          this.router.navigateByUrl("offboarding");
        } else {
          this.errors = data["result"];
          this.flashService.show(data["message"], "alert-success");
          this.router.navigateByUrl("offboarding");
        }
        this.spinnerService.hide();
      },
      (error) => {
        this.spinnerService.hide();
        this.errorService.errorHandling(error);
      }
    );
  }

  generateForm() {
    this.form = new FormGroup({
      fields: new FormControl(JSON.stringify(this.fields)),
    });

    this.form = new FormGroup({});
    this.fields.forEach((x) => {
      if (x.type == "checkbox") {
        this.form.addControl(x.name, new FormGroup({}));

        x.options.forEach((o) => {
          (this.form.get(x.name) as FormGroup).addControl(
            o.key,
            new FormControl(false)
          );

        });
      } else {
        this.form.addControl(
          x.name,
          new FormControl(
            x.value || "",
            x.required ? Validators.required : null
          )
        );
      }
    });
  }

  back(){
    this.router.navigate(['/offboarding'])
  }
}



// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/offboarding/forms-view/exit-checklist-views/exit-checklist-views.component.ts